import React from 'react';
import {
  EmptyState,
  EmptyStateBody,
  EmptyStateFooter,
  EmptyStateActions,
  EmptyStateStatus,
  Button,
} from '@patternfly/react-core';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <EmptyState titleText="404 - Page not found" headingLevel="h1" status={EmptyStateStatus.danger}>
    <EmptyStateBody>The page you are looking for does not exist.</EmptyStateBody>
    <EmptyStateFooter>
      <EmptyStateActions>
        <Button variant="primary" component={(props) => <Link {...props} to="/weekly-view" />}>
          Go to Weekly View
        </Button>
      </EmptyStateActions>
    </EmptyStateFooter>
  </EmptyState>
);

export default NotFound;
